export default __webpack_public_path__ + "static/media/pid.b32e2dd6.png";